import api from "../../api.js";

export async function listSplitCandidates({ search = "", page = 1, pageSize = 10 } = {}) {
  const params = { search, page: String(page), pageSize: String(pageSize) };
  const res = await api.get("/api/profiles/split/candidates", { params });
  return {
    data: res.data?.data || [],
    total: Number(res.data?.total || 0),
    page: Number(res.data?.page || page),
    pageSize: Number(res.data?.pageSize || pageSize),
  };
}

export async function splitProfile(payload) {
  const res = await api.post("/api/profiles/split", payload);
  return res.data;
}
